/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// this file does nothing and used just to import it instead of some other file (see webpack config)

export const __stub__ = '@gh/core-util/stub';
